import { render, staticRenderFns } from "./GenerationServiceTerms.vue?vue&type=template&id=490c4bfc&scoped=true"
import script from "./GenerationServiceTerms.vue?vue&type=script&lang=js"
export * from "./GenerationServiceTerms.vue?vue&type=script&lang=js"
import style0 from "./GenerationServiceTerms.vue?vue&type=style&index=0&id=490c4bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c4bfc",
  null
  
)

export default component.exports